<div class="container">
  <div class="header">
    <div class="title">
      <span [fiTranslation]="messageSnippet"></span>
    </div>
    <button (click)="onClosePopup()">
      <img alt="Close" src="/assets/icons/close-icon.svg">
      <span class="u-hidden-visually" fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </button>
  </div>

  @if (customDescriptionSnippet) {
    <div class="description" [fiTranslation]="customDescriptionSnippet" [replaceKeys]="replaceKeys" [params]="descriptionParams"></div>
  }

  <div class="button-row">
    @if (hasCancel) {
      <button class="cancel" (click)="cancel()">
        <span class="btn-title" [fiTranslation]="cancelSnippet" [replaceKeys]="replaceKeys"></span>
      </button>
    }

    <button (click)="confirm()" [class.only-button]="!hasCancel">
      <span class="btn-title" [fiTranslation]="confirmSnippet" [replaceKeys]="replaceKeys"></span>
    </button>
  </div>

</div>

